import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3 11.976c.052-4.887 3.879-8.828 8.73-8.972 4.996-.147 9.213 3.734 9.27 8.89.055 4.923-3.756 8.987-8.791 9.103C7.2 21.114 3.052 17.13 3 11.978m16.621-.004c.035-4.03-3.166-7.49-7.483-7.586a7.576 7.576 0 0 0-7.753 7.308c-.173 4.118 2.978 7.845 7.568 7.92a7.573 7.573 0 0 0 7.668-7.643z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.041 10.491v-1.89q0-.19.02-.377a.694.694 0 0 1 .724-.624c.35.02.652.327.652.689q.005 1.866-.01 3.733c0 .134.04.205.154.274q1.427.865 2.846 1.741c.372.231.48.627.279.96-.165.272-.518.406-.808.273-.243-.11-.468-.258-.697-.396a923 923 0 0 1-2.796-1.7.68.68 0 0 1-.342-.601c-.005-.694-.002-1.386-.002-2.08h-.02z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ClockIcon24.js.map